import { isDisconnectType, isServiceRequestType } from "./helper";
import EquipmentUtils from "./EquipmentUtils";

const
  TV_PLUS_MESSAGE = "WOW!TV+",
  EERO_MESSAGE = "EERO",
  MODEM_MESSAGE = "HSD",
  LTE_MESSAGE = "LTE",
  WIFI_EXTENDER_MESSAGE = "TP-LINK - Wi-Fi Extender",
  YTTVSTB_MESSAGE = "YTTV STB";

export const
  EERO_PRO_PRIMARY_EQUIPMENT_CODE = "6145",
  EERO_PRO_ADTL_EQUIPMENT_CODE = "6146",
  EERO_PRO_COM_PRIMARY_EQUIPMENT_CODE = "6191",
  EERO_PRO_COM_ADTL_EQUIPMENT_CODE = "6192",
  EERO_BASE_SERVICE_CODE = '6162',
  EERO_BEACON_SERVICE_CODE = '6163',
  EMPLOYEE_EERO_BASE_SERVICE_CODE = 'EM6162',
  EMPLOYEE_EERO_BEACON_SERVICE_CODE = 'EM6163',
  EERO_PRIMARY_EQUIPMENT_CODE = '6170',
  EERO_ADTL_EQUIPMENT_CODE = '6171',
  TV_PLUS_SERVICE_CODE = '6400',
  EMPLOYEE_EERO_PRIMARY_EQUIPMENT_CODE = 'EM6170',
  EMPLOYEE_EERO_ADTL_EQUIPMENT_CODE = 'EM6171',
  TV_PLUS_CUSTOMER_CODE = 'EM6400',
  INTERNET_1200_CODES = ['4122', 'PR40005'],
  INTERNET_1200_BIZ_CODE = '4209',
  INTERNET_1200_EMP_CODE = 'EM4122',
  FREE_1200_HSDS = ['6158', 'EQ60000'],
  FREE_1200_HSD_EMP = 'EM6158',
  EMPLOYEE_EERO_PRO_ADTL_EQUIPMENT_CODE = 'EM6146',
  EMPLOYEE_EERO_PRO_PRIMARY_EQUIPMENT_CODE = "EM6145",
  EMTA_REPLACE_CODE = '6165',
  HOME_NETWORK_EMTA_REPLACE_CODE = '6166',
  WIFI_ACCESS_ROUTER = '6147', // TPLink
  COMMERCIAL_FIBER_CODE = '6190'

export const wifiRangeExtenderServiceCodes = ['6149', '6194',];
export const eero7PrimServiceCodes = ['EQ61001', 'EQ65001'];
export const eero7EmployeePrimServiceCodes = ['EM6149'];
export const eero7EmployeeAddtServiceCodes = ['EM6150'];
export const eero7AddtServiceCodes = ['EQ61002', 'EQ65002'];

export const yttvIntentServiceCodes = ['3101'];
export const yttvSTBServiceCodes = ['EQ61000'];

export const eeroServiceCodes = [
  EERO_PRIMARY_EQUIPMENT_CODE,
  EERO_ADTL_EQUIPMENT_CODE,
  EERO_BASE_SERVICE_CODE,
  EERO_BEACON_SERVICE_CODE,
  EMPLOYEE_EERO_BASE_SERVICE_CODE,
  EMPLOYEE_EERO_BEACON_SERVICE_CODE,
  EMPLOYEE_EERO_PRIMARY_EQUIPMENT_CODE,
  EMPLOYEE_EERO_ADTL_EQUIPMENT_CODE,
  EERO_PRO_PRIMARY_EQUIPMENT_CODE,
  EERO_PRO_ADTL_EQUIPMENT_CODE,
  EMPLOYEE_EERO_PRO_ADTL_EQUIPMENT_CODE,
  EMPLOYEE_EERO_PRO_PRIMARY_EQUIPMENT_CODE,
  EERO_PRO_COM_PRIMARY_EQUIPMENT_CODE,
  EERO_PRO_COM_ADTL_EQUIPMENT_CODE,
];

export const eeroCommunitySC = ["AD40001"]

export const legacyFiberServiceCodes = [
  "6182", "6183", "6136", "6139", "6141", "6142", "6210", "9992940", "EQ60001"
];

export const fiberServiceCodes = [
  ...legacyFiberServiceCodes, COMMERCIAL_FIBER_CODE
];

export const free1200Modems = [
  ...FREE_1200_HSDS,
  FREE_1200_HSD_EMP
];

export const internet1200Codes = [
  ...INTERNET_1200_CODES,
  INTERNET_1200_EMP_CODE,
  ...FREE_1200_HSDS,
  FREE_1200_HSD_EMP
];

export const bizInternet1200Codes = [
  INTERNET_1200_BIZ_CODE];

export const wholesale1200Codes = [
  '4470'
]

export const internet2000Codes = [
  '4123',
  'EM4123',
  'PR40006'
];

export const lteFailoverCodes = [
  "6186", "6187", "6188", "6189"
];

const tvPlusServiceCodes = [
  TV_PLUS_SERVICE_CODE,
  TV_PLUS_CUSTOMER_CODE
];

const
  ICOMS_EERO_BASE_MODEL = 'EROBASE',
  ICOMS_EERO_BEACON_MODEL = 'EROBCON',
  ICOMS_EERO_SIX_MODEL = 'EEROSIX',
  ICOMS_EERO_SIX_PRO_MODEL = 'EEROPRO',
  ICOMS_EERO_SIX_PRIM = "EROPRIM",
  ICOMS_EERO_SIX_ADDL = "EROADDL";
const EERO_UNIVERSAL_MODELS = [
  "WHWF Universal Primary",
  "WHWF Universal Additional",
  "Bulk WHWF Univ. Primary",
  "Bulk WHWF Univ. Additional"
];

export const icomsEeroModels = [
  ICOMS_EERO_SIX_MODEL,
  ICOMS_EERO_SIX_PRO_MODEL,
  ICOMS_EERO_BASE_MODEL,
  ICOMS_EERO_BEACON_MODEL,
  ICOMS_EERO_SIX_PRIM,
  ICOMS_EERO_SIX_ADDL,
  ...EERO_UNIVERSAL_MODELS
];

export const customerOwnedServiceCodes = [
  '6100', '6054', '9990833', '9991032', 'EM1032'
];

export const sikMoveTransferCodes = [
  '7145'
];

export const gponModels = [
  '72101G', '721010G', '711GE', '716GE', '762GX', '763GXR', '742GE', '766GX', '766GXR', 'ONT854G', 'ONT812G', '725GE', '721GE', '720GX', '720G', '727GE'
];

export const greenFieldSignalAccessCodes = [
  'X'
]

export const fiberTerminalServiceCodes = [
  "6144", "6136", "6139", "6182", "6183", "6190", "EQ60001"
];

export const eeroUniversalAdditionalCodes = [
  "EQ61012", "EQ61014"
];

export const eeroUniversalCodes = [
  "EQ61011", "EQ61013", ...eeroUniversalAdditionalCodes
];

export function equipmentNeededForWorkOrderClosure(equipmentDetails, serviceTypeId, allEquipmentNeeded, skipValidation) {
  function setValidationMessage(type) {
    return 'Please assign equipment to all ' + type + ' occurrences in the Equipment screen before closing this order';
  }

  const validation = {
    isValid: true,
    message: null
  };

  if (!equipmentDetails || skipValidation) {
    return validation;
  }

  if (allEquipmentNeeded) {
    return missingEquipment(equipmentDetails) ?
      { isValid: false, message: "'Please assign equipment to all occurrences in the Equipment screen before closing this order" } : validation;
  }

  if (!(isDisconnectType(serviceTypeId) || isServiceRequestType(serviceTypeId))) {
    if (tvPlusEquipmentNeeded(equipmentDetails)) {
      return { isValid: false, message: setValidationMessage(TV_PLUS_MESSAGE) };
    }
    if (eeroEquipmentNeeded(equipmentDetails)) {
      return { isValid: false, message: setValidationMessage(EERO_MESSAGE) };
    }
    if (modemEquipmentNeeded(equipmentDetails)) {
      return { isValid: false, message: setValidationMessage(MODEM_MESSAGE) };
    }
    if (lteEquipmentNeeded(equipmentDetails)) {
      return { isValid: false, message: setValidationMessage(LTE_MESSAGE) };
    }
    if (wifiRangeExtenderEquipmentNeeded(equipmentDetails)) {
      return { isValid: false, message: setValidationMessage(WIFI_EXTENDER_MESSAGE) };
    }
    if (YTTVSTBEquipmentNeeded(equipmentDetails)) {
      return { isValid: false, message: setValidationMessage(YTTVSTB_MESSAGE) };
    }
  }

  return validation;
}

export function missingEquipment(equipmentDetails) {
  return equipmentDetails.some(equipment => !equipment.get('macAddress'));
}

export function tvPlusEquipmentNeeded(equipmentDetails) {
  function determineIfEquipmentIsTvPlus(item) {
    const serviceCodeList = item.get('serviceCodeList');

    return serviceCodeList.some(code => tvPlusServiceCodes.includes(code.get('code').trim())) && !item.get("macAddress")
      && !EquipmentUtils.isEquipmentRemovalOnly(item);
  }

  return equipmentDetails.some(equipment => determineIfEquipmentIsTvPlus(equipment));
}

export function eeroEquipmentNeeded(equipmentDetails) {
  function determineIfEquipmentIsEero(equipment) {
    return icomsEeroModels.indexOf(equipment.get('model')) >= 0 && !equipment.get('macAddress')
      && !EquipmentUtils.isEquipmentRemovalOnly(equipment);
  }

  return equipmentDetails.some(equipment => determineIfEquipmentIsEero(equipment));
}

export function modemEquipmentNeeded(equipmentDetails) {
  return equipmentDetails.some(equipment =>
    EquipmentUtils.isModemEquipmentNeeded(equipment) && !EquipmentUtils.isCustomerOwnedModem(equipment)
    && !equipment.get('macAddress') && !EquipmentUtils.isEquipmentRemovalOnly(equipment)
  );
}

export function lteEquipmentNeeded(equipmentDetails) {
  return equipmentDetails.some(equipment =>
    EquipmentUtils.isLTEEquipmentNeeded(equipment) && !EquipmentUtils.isCustomerOwnedModem(equipment)
    && !equipment.get('macAddress') && !EquipmentUtils.isEquipmentRemovalOnly(equipment)
  );
}

export function fiberEquipmentNeeded(equipmentDetails) {
  function determineIfEquipmentIsFiberModem(item) {
    const serviceCodeList = item.get('serviceCodeList');
    return serviceCodeList.some(code => fiberServiceCodes.includes(code.get('code').trim())) && !item.get("macAddress")
      && !EquipmentUtils.isEquipmentRemovalOnly(item);
  }
  return equipmentDetails.some(equipment => determineIfEquipmentIsFiberModem(equipment));
}

export function wifiRangeExtenderEquipmentNeeded(equipmentDetails) {
  function determineIfEquipmentIswifiRangeExtender(item) {
    const serviceCodeList = item.get('serviceCodeList');
    return serviceCodeList.some(code => wifiRangeExtenderServiceCodes.includes(code.get('code').trim())) && !item.get("macAddress")
      && !EquipmentUtils.isEquipmentRemovalOnly(item);
  }
  return equipmentDetails.some(equipment => determineIfEquipmentIswifiRangeExtender(equipment));
}

export function YTTVSTBEquipmentNeeded(equipmentDetails) {
  function determineIfEquipmentIsYTTVSTB(item) {
    const serviceCodeList = item.get('serviceCodeList');
    return serviceCodeList.some(code => yttvSTBServiceCodes.includes(code.get('code').trim())) && !item.get("macAddress")
      && !EquipmentUtils.isEquipmentRemovalOnly(item);
  }
  return equipmentDetails.some(equipment => determineIfEquipmentIsYTTVSTB(equipment));
}



// WEBPACK FOOTER //
// ./src/utils/accountEquipmentValidators.js